import { useIntl } from 'react-intl';

import { PROD_DEFAULT_REGION } from 'state/intl/hook';
import {
  ISOs,
  defaultInputProperties,
  defaultLocaleKeys,
  postalCodeStringLocaleKey,
  regionInputProperties,
  regionStringLocaleKey,
} from 'utils/form/constants';

const useCreditCardFormProps = (isoCountryCode: ISOs = ISOs[PROD_DEFAULT_REGION]) => {
  // construct postal code props based on users country
  const { formatMessage } = useIntl();
  const postalCodeInputProps = {
    label: formatMessage({
      id: postalCodeStringLocaleKey[isoCountryCode] ?? defaultLocaleKeys.postalCode,
    }),
  };
  const regionInputProps = {
    label: formatMessage({ id: regionStringLocaleKey[isoCountryCode] ?? defaultLocaleKeys.region }),
    ...(regionInputProperties[isoCountryCode] ?? defaultInputProperties.region),
  };

  return { postalCodeInputProps, regionInputProps };
};

export default useCreditCardFormProps;
